import React from 'react';
import { LogoHeader } from '../Components/Inicio/LogoHeaderComponent';
import { NavDesktop } from '../Components/Inicio/NavDesktop';
import { NavMobile } from '../Components/Inicio/NavMobile';
import { AddUserComponent } from '../Components/AddUserComponent';
import { Footer } from '../Components/Footer/FooterComponent';

export const AddUserPage = (props) => {
    return (
        <>
            <LogoHeader I18n={props.I18n} />
            <NavDesktop I18n={props.I18n} />
            <NavMobile I18n={props.I18n} />
            <AddUserComponent I18n={props.I18n} />
            <Footer I18n={props.I18n} />
        </>
    );
};